import { Component } from '@theme/component';

const FEEDBACK_DURATION_MS = 2500;

/**
 * Handles copying text to clipboard, from an event like a click.
 * Shows optional success message (ref="copySuccessMessage") and resets after a delay.
 * @extends {Component}
 */
class CopyToClipboardComponent extends Component {
  /** @type {ReturnType<typeof setTimeout> | undefined} */
  #feedbackTimeoutId;

  copyToClipboard() {
    const copyContent = this.getAttribute('text-to-copy');

    if (!copyContent) return;

    const copySuccessMessage = this.refs.copySuccessMessage;

    const showFeedback = () => {
      if (copySuccessMessage instanceof Element) {
        copySuccessMessage.classList.remove('visually-hidden');
      }
      this.#feedbackTimeoutId = setTimeout(() => {
        this.#feedbackTimeoutId = undefined;
        if (copySuccessMessage instanceof Element) {
          copySuccessMessage.classList.add('visually-hidden');
        }
      }, FEEDBACK_DURATION_MS);
    };

    const hideFeedback = () => {
      if (this.#feedbackTimeoutId) {
        clearTimeout(this.#feedbackTimeoutId);
        this.#feedbackTimeoutId = undefined;
      }
      if (copySuccessMessage instanceof Element) {
        copySuccessMessage.classList.add('visually-hidden');
      }
    };

    if (this.#feedbackTimeoutId) {
      clearTimeout(this.#feedbackTimeoutId);
      this.#feedbackTimeoutId = undefined;
    }

    navigator.clipboard
      .writeText(copyContent)
      .then(showFeedback)
      .catch(() => {
        hideFeedback();
      });
  }
}

if (!customElements.get('copy-to-clipboard-component')) {
  customElements.define('copy-to-clipboard-component', CopyToClipboardComponent);
}
